import { ElementType, FC, ReactElement } from 'react'

import { HomeIcon, LockerIcon, ShopIcon } from '@dhl-ui/icons'
import { Servicepoint } from './model.js'

type ServicepointIconProps = Pick<Servicepoint, 'servicepointType' | 'servicepointFormat'> & {
  component?: ElementType
}

const renderIcon = ({
  servicepointType,
  servicepointFormat,
}: Pick<Servicepoint, 'servicepointType' | 'servicepointFormat'>): ReactElement => {
  const lockerIcon = <LockerIcon sx={{ mt: 0.5 }} />

  if (servicepointType === 'PackStation') {
    return lockerIcon
  }

  switch (servicepointFormat) {
    case 'Buurtpunt':
      return <HomeIcon />
    case 'DHL Pakketautomaat':
    case 'Pakketautomaat DeBuren':
    case 'Pakketautomaat SmartMile':
      return lockerIcon
    case 'Shop':
    case 'Avondwinkel':
    default:
      return <ShopIcon />
  }
}

export const ServicepointIcon: FC<ServicepointIconProps> = ({ servicepointFormat, servicepointType }) =>
  renderIcon({ servicepointFormat, servicepointType })
